/* Menubalk: schaduw en krimp na scrollen, en de winkelmandbubbel veert bij een nieuw aantal. */
(function () {
  var tick = false;
  function update() { tick = false; document.body.classList.toggle('lp-scrolled', window.scrollY > 24); }
  window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(update); } }, { passive: true });
  update();
  var host = document.getElementById('cart-icon-bubble');
  if (host && 'MutationObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    new MutationObserver(function () {
      var b = host.querySelector('.cart-count-bubble');
      if (!b) return;
      b.classList.remove('lp-bump'); void b.offsetWidth; b.classList.add('lp-bump');
      var link = host.closest('.header__icon--cart') || host; link.classList.remove('lp-hop'); void link.offsetWidth; link.classList.add('lp-hop');
    }).observe(host, { childList: true, subtree: true, characterData: true });
  }
})();

/* Mandje: kop met de naam van het huisdier, indien ingevuld. */
(function () {
  function name() {
    var pet = window.LapusiePet && window.LapusiePet.get();
    document.querySelectorAll('[data-lp-cart-title]').forEach(function (h) {
      h.textContent = pet && pet.name ? h.getAttribute('data-named').replace('{name}', pet.name) : h.getAttribute('data-default');
    });
  }
  document.addEventListener('DOMContentLoaded', name);
  document.addEventListener('lapusie:pet-change', name);
  document.addEventListener('cart-drawer:refresh', name);
  window.addEventListener('load', name);
})();
